import React, { useCallback } from 'react';
// import './GlobalHeaderActionsCell.less'
import { HeaderActionsColumn } from '../columns';
import { Cell } from '../cells';
import { HeaderActions, PhraseItem } from './../components';
import { IHeaderAction } from '../components/HeaderActions';
import { ActionModel } from 'domains/designers/RuleDesigner/models/ActionModel';
import { BaseRuleActionHandler } from 'domains/designers/RuleDesigner/models/BaseRuleActionHandler';
import { getAnchorIssues } from 'domains/designers/RuleDesigner/RuleActionUtils';
import { ValidationIcon } from 'domains/designers/common';

export interface IGlobalHeaderActionsCellProps {
  action: ActionModel;
  handler: BaseRuleActionHandler;
  isDebugMode: boolean;
}

/**
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function GlobalHeaderActionsCell({ action, handler, isDebugMode }: IGlobalHeaderActionsCellProps) {
  const handleChange = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      handler.change(e.target as HTMLElement);
    },
    [handler]
  );
  const headerIssues = getAnchorIssues(action.getValidationIssues());

  const actions: IHeaderAction[] = [
    {
      /*TODO alex: Rename method to "onRemoveClick" or css className to "tt-result-delete" to be consistent */
      iconClassName: 'tt-result-remove',
      title: 'Remove action',
      action: e => handler.remove(e.target as HTMLElement),
    },
    {
      iconClassName: 'tt-result-edit',
      title: 'Edit action',
      action: handleChange,
    },
  ];

  return (
    <HeaderActionsColumn isHeader={true} data-column-name={action.ActionName}>
      <Cell className="flex-centering">
        {headerIssues && <ValidationIcon validationIssues={headerIssues} />}
        <PhraseItem onClick={handleChange} disabled={isDebugMode}>
          {action.ActionName}
        </PhraseItem>
        {!isDebugMode && <HeaderActions actions={actions} />}
      </Cell>
    </HeaderActionsColumn>
  );
}
